(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eufy-full-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('eufy-navigation'))customElements.define('eufy-navigation',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const signal=this.abort.signal;this.dialog=this.querySelector('dialog');
  document.addEventListener('click',event=>{const trigger=event.target.closest('[data-eufy-menu-open]');if(!trigger)return;event.preventDefault();this.trigger=trigger;this.dialog.showModal();document.documentElement.classList.add('eufy-menu-lock');trigger.setAttribute('aria-expanded','true');this.querySelector('[data-eufy-menu-close]').focus();},{signal});
  this.querySelector('[data-eufy-menu-close]').addEventListener('click',()=>this.dialog.close(),{signal});
  this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('eufy-menu-lock');this.trigger?.setAttribute('aria-expanded','false');this.trigger?.focus();},{signal});
 }
 disconnectedCallback(){this.abort?.abort();if(this.dialog?.open)this.dialog.close();document.documentElement.classList.remove('eufy-menu-lock');}
});
  } catch(e) { console.error(e); }
})();

})();
